<div class="search-box-container">
  <div class="content" [formGroup]="form">
    <label for="searchBox"></label>
    <input
      id="searchBox"
      type="text"
      [placeholder]="'search.placeholder' | translate"
      formControlName="search"
    />
    <img
      [hidden]="search.value.length >= 1"
      class="search-icon"
      src="./assets/icons/search_icon.svg"
      alt="search_icon"
      title="search_icon"
    />
    <img
      [hidden]="search.value.length < 1"
      class="search-icon-remove"
      src="./assets/icons/remove_icon.svg"
      alt="remove_icon"
      title="remove_icon"
      (click)="clearSearchBox()"
    />
  </div>
</div>
